<template>
    <q-dialog
        v-model="display"
        persistent
        :maximized="maximizedToggle"
        transition-show="slide-up"
        transition-hide="slide-down"
    >
        <q-layout view="lHh lpr lFf" container class="bg-white shadow-2 rounded-borders">
            <q-header class="bg-primary">
                <q-toolbar>
                    <q-toolbar-title>{{dialogTitle}}</q-toolbar-title>
                    <q-btn flat v-close-popup round dense icon="fa fa-times" />
                </q-toolbar>
            </q-header>

            <q-page-container>
                <q-page class="q-pa-none">
                    <chat-box
                        :noteable-id="noteableId"
                        :noteable-type="noteableType"
                        style="width: 100%"
                        @made="made"
                        @edited="edited"
                    />
                </q-page>
            </q-page-container>
        </q-layout>
    </q-dialog>
</template>
<script>

import ChatBox from "./ChatBox.vue"
export default {
    name: "NotesDialog",
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        dialogTitle: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        },
        noteableType: {
            type: String,
            required: true
        },
        noteableId: {
            type: [Number, String],
            required: true
        }
    },
    computed: {
        display: {
            get: function () {
                return this.show
            },
            set: function (value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {
            maximizedToggle: false,
            displayChatBox: false,
            chatUserId: undefined,
        }
    },
    methods: {
        made(note) {
            this.$emit('made', note)
        },
        edited(note) {
            this.$emit('edited', note)
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {
        ChatBox
    },
}
</script>
<style>

</style>
